import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.products.EditProductView.StepPhotos.hint.p1")}</p>
    <p>{I18n.t("papp.products.EditProductView.StepPhotos.hint.p2")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPhotos/StepPhotosHint.jsx